import en from "../commons/locales/en";
import vi from "../commons/locales/vi";
import StringLocalization from "../lib/localization";

const Strings = StringLocalization({ en, vi });

export default Strings;
